<template>
  <div class="home">
    <div class="Home_box">
      <div class="Home_box_big" v-for="(i,item) in JsonData" :key="item">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <div>{{item == 'EventStatList1' ? '最佳得分手' 
              :item == 'EventStatList2' ? '最佳发球手'
              :item == 'EventStatList3' ? '最佳拦网手' 
              :item == 'EventStatList4' ? '最佳得分手'
              :item == 'EventStatList5' ? '最佳发球手' 
              :item == 'EventStatList6' ? '最佳拦网手' 
              :item == 'EventStatList7' ? '最佳扣球手' 
              :item == 'EventStatList8' ? '最佳扣球手' 
              :item == 'EventStatList9' ? '最佳一传手' : ''}}</div>
            <P>{{item == 'EventStatList1' ? '(得分 / 局)' : item == 'EventStatList2' ? '(发球得分 / 局)' 
              :item == 'EventStatList3' ? '(拦网得分 / 局)' :item == 'EventStatList4' ? '(得分)' 
              :item == 'EventStatList5' ? '(发球得分)' :item == 'EventStatList6' ? '(拦网得分)' :
              item == 'EventStatList7' ? '(扣球得分/局)' :item == 'EventStatList8' ? '(扣球得分)' :
              item == 'EventStatList9' ? '(非常到位 - 失误) / 局' : ''}}</P>
            <!-- <span>{{item == EventStatList1 ? '最佳得分手(得分 / 局)' : }}</span> -->
            <!-- <span v-if="item=='EventStatList1'">最佳得分手(得分 / 局)</span>
            <span v-if="item=='EventStatList2'">最佳发球手(发球得分 / 局)</span>
            <span v-if="item=='EventStatList3'">最佳拦网手(拦网得分 / 局)</span>
            <span v-if="item=='EventStatList4'">最佳得分手(得分)</span>
            <span v-if="item=='EventStatList5'">最佳发球手(发球得分)</span>
            <span v-if="item=='EventStatList6'">最佳拦网手(拦网得分)</span>
            <span v-if="item=='EventStatList7'">一传 - positivity %(一传非常到位 + 一传到位) / 全部一传</span>
            <span v-if="item=='EventStatList8'">进攻 - excellent %进攻得分 / 所有进攻</span>
            <span v-if="item=='EventStatList9'">最佳防守(扣球防起能攻+拦网保护起球 / 局)</span> -->
          </div>
          <ul class="CardList">
            <li v-for="(o,index) in i" :key="index" >
              <div class="CardList_rank">
                <p>{{o.Rank}}°</p>
                <p>#{{o.ShirtNumber}}</p>
              </div>
              <div class="CardList_symbol"> | </div>
              <div class="CardList_name">
                <p>{{o.RegisterName}}</p>
                <p>{{o.TeamName}}</p>
              </div>
              <div class="CardList_data">
                <p>{{o.Ratio}}</p>
                <p>{{o.RatioDes}}</p>
              </div>
            </li>
            <div class="more_ranking">
              <el-button type="primary" icon="el-icon-s-unfold" @click="handleMore(item)"></el-button>
            </div>
            
          </ul>
          
        </el-card>

      </div>
      

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import http from '@/assets/js/http.js';
import UrlEncode from '../assets/js/UrlEncode.js' 

export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  props:['sport','event'],
  data() {
      return {
        SportID: 0,
        JsonData: null,
        my_data:null,
        EventID: 0,
      }
  },
  watch: {
      sport(newVal,oldVal){
        // console.log('这是新值111:',newVal)
        // console.log('这是laozh1111i:',oldVal)
        this.SportID = newVal;
      },
      event(newVal,oldVal){
        console.log(newVal,oldVal)
        // console.log(newVal)
        this.EventID = newVal;
        if(newVal != null){
          this.EventID = newVal;
          
          if(oldVal != 0 || this.$cookie.get('EventID') == null){
            console.log('来自event监控请求')
            this.GetEventStatHome(newVal);//获取首页9大统计数据接口
            this.$cookie.set('EventID',newVal,'2h');
          }else if(this.$route.query.key == undefined&& this.$cookie.get('EventID') == null){
            console.log('来自event监控请求2222')
            // this.EventID = newVal;
            this.GetEventStatHome(newVal);//获取首页9大统计数据接口
          }else{
            this.GetEventStatHome(newVal);//获取首页9大统计数据接口
          }
        }else{
          console.log('meiyou    event')
        }
        
        
      },
      $route: { // 亲测有效,我是用来监听query参数变化
            handler(newVal,oldVal) {
                // this.id = this.$route.query.id;
                // this.getDetail();
                // console.log('这是新值:',newVal)
                // console.log('这是laozhi:',oldVal)
                //深度监听，同时也可监听到param参数变化
                let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
                this.my_data = params;
                // this.PhaseID = params.phaseID;
                // this.PhaseName = params.phaseName;
                // console.log(params)
                // console.log('来自路由请求请求')
                // this.GetEventStatHome(params.EventID);//获取首页9大统计数据接口
            },
            deep: true,
      },
        // immediate: true,

  },
  // beforeRouteEnter(to, from, next) {
  //   // 在渲染该组件的对应路由被 confirm 前调用
  //   // 不！能！获取组件实例 `this`
  //   // 因为当守卫执行前，组件实例还没被创建
  //   console.log(to)
  //   console.log(from)
  //   // getPost(to.params.id, (err, post) => {
  //   //   next(vm => vm.setData(err, post))
  //   // })
  //   //判断该页面有channel
  //   if(from.query){
  //       //路由切换时，如果没有就添加，有就跳过执行，添加固定参数
  //       if (!to.query.key) {
  //           //准备一个跳转的query对象
  //           // let query = to.query;
  //           let query = {
  //             key: UrlEncode.encode(JSON.stringify({
  //                     sportID: this.$cookie.get('SportID'),
  //                     phaseID: 0,
  //                     phaseName: '',
  //                     sportName: '',
  //                     details: 0,
  //                   }))
  //           };
  //           next({
  //             path: to.path,
  //             query: query
  //           })
  //       } else {
  //           next()
  //       }
  //   }else{
  //       next()
  //   }
  // },
  created(){
    // this.
    // console.log(this.$route)
    if(this.$route.query.key != undefined){
      let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
      this.my_data = params;
      console.log(params)
      console.log('来自url页面请求')
      let enen11 = this.$cookie.get('EventID');
      // this.EventID = params.EventID
      if(enen11 != params.EventID){
        this.GetEventStatHome(enen11);//获取首页9大统计数据接口
      }else{
        this.GetEventStatHome(this.my_data.EventID);//获取首页9大统计数据接口
      }
      
    }else{
      // console.log(this.$route.query.key)
      // console.log('没有key123');
      // console.log(this.$data)
      
      // this.$nextTick(() =>{
      //   let enen = this.$cookie.get('EventID');
      //   console.log(enen)
      // console.log(this.EventID)
      //   if(this.EventID != 0){
      //     setTimeout(()=>{
      //       this.GetEventStatHome(this.EventID);//获取首页9大统计数据接口
      //     },500)
      //   }else{
      //     setTimeout(()=>{
      //       let enen = this.$cookie.get('EventID');
      //       console.log(enen)
      //       this.GetEventStatHome(enen);//获取首页9大统计数据接口
      //     },1000)
      //   }


        
      // })
      
      
      // this.GetEventStatHome(this.sport);//获取首页9大统计数据接口
    }
    
    // console.log(this.$route.query.key)
    
  },
 
  methods:{
    handleMore(str){
      // this.$router.push('/HomeRank');
      // console.log(str.substr(str.length-1,1))
      // console.log(this.sport)
      // console.log(str)
      console.log(this.my_data)
      // console.log(this.EventID)
      if(this.my_data !=  null){
        this.my_data.EventID = this.$cookie.get('EventID');
        this.$router.push({
          path: "/HomeRank",
          query:{
            key:this.$UrlEncode.encode(JSON.stringify({
              sportID: this.my_data.sportID,
              phaseID: this.my_data.phaseID,
              phaseName: this.my_data.phaseName,
              sportName: this.my_data.sportName,
              details:str.substr(str.length-1,1),
              EventID: this.my_data.EventID,
              pageSize: 10,
              pageIndex:1,
            }))
          }
        })
      }else{
        this.$router.push({
          path: "/HomeRank",
          query:{
            key:this.$UrlEncode.encode(JSON.stringify({
              sportID: this.sport,
              phaseID: 0,
              phaseName: 0,
              sportName: 0,
              details:str.substr(str.length-1,1),
              EventID: this.EventID,
              pageSize: 10,
              pageIndex:1,
            }))
          }
        })
      }

      
    },
    GetEventStatHome(ID){//获取首页9大统计数据接口
      http.GetEventStatHome(ID).then(res=>{////获取首页9大统计数据接口
          // console.log(res)
          if(res.Status == 1){
            this.JsonData = res.DataResult;
            // console.log(this.JsonData)
            // for(let (i,item) in this.JsonData){
            //   console.log(i)
            // }

          }else if(res.Status == 0){
            this.JsonData = {};
            this.$message.error({message:'暂无数据!',duration: 1500,showClose: true,});
          }else{
            this.$message.error(
              {message:'本赛季获取信息失败!',
              duration: 1500,
              showClose: true,
            });
          }
      })


    },
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-card__body{
    padding: 0 20px 15px 20px;
  }
 
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  .home{
    max-width: 1200px;
    margin: 20px auto;
  }
  .Home_box{
    width: 100%;
    font-size: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
    justify-content: space-around;
        // justify-content: center;
  }
  .Home_box_big{
    flex: 0 1 31%;
    margin-bottom: 10px;
    font-size: 16px;
    
  }
  @media screen and (min-width: 769px) and (max-width: 1024px){
    .Home_box_big{
      flex: 0 1 47%;
      margin-bottom: 10px;
    }
  }
  @media (max-width: 1100px){
    .Home_box_big{
      flex: 0 1 47%;
      margin-bottom: 10px;
    }
  }
  @media screen and (min-width: 361px) and (max-width: 768px){
    .Home_box_big{
      flex: 0 1 90%;
    }
  }
  .CardList{
    width: 100%;
    li{
      width: 100%;
      padding: 10px 0;
      border-bottom: 1px solid #EBEEF5;
      display: flex;
      line-height:20px;
      .CardList_rank{
        // flex: 1;
        width: 10%;
      }
      .CardList_symbol{
        width: 4%;
      }
      .CardList_name{
        flex: 1;
        text-align: left;
        
      }
      .CardList_data{
        width: 32%;
        // display: flex;
        // align-items: center;
        // align-content: center;
        // // justify-items: center;
        // flex-wrap: wrap;
        // p{
        //   width: 100%;
        //   // flex: 1 1 at;
        //   // align-items: center;
        // }
      }
    }
    .more_ranking{
      margin-top: 10px;
    }
  }

</style>
